// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hR17","content":"styles_content__1xRaG","row":"styles_row__3sliB","footer":"styles_footer__3zRue","phraseLength":"styles_phraseLength__1oheW"};